<script>
    import dressing from "@intellectability/platform-common";

    import {create_security_error, generate_time_array} from "@intellectability/platform-common/utils";
    
    // common constants
    import {ACTIONS} from "@intellectability/platform-common/constants";

    // common components
    import {
        AutoPen,
        AutoUpdateInput,
        Icon,
        toast,
        ExportButtons,
        MegaPopup,
        AutoUpdateSet,
    } from "@intellectability/platform-common/sv";

    // bootstrap
    import {
        Breadcrumb,
        BreadcrumbItem,
        Row,
        Col,
        Button
    } from "@sveltestrap/sveltestrap";

    import {createForm} from "svelte-forms-lib";
    import * as yup from "yup";
    import EntityChangeHistory from "./lib/EntityChangeHistory.svelte";

    import homeVisitsBreadcrumb from "./lib/home-visits-breadcrumb.svg";

    import homeVisitsIcon from "./lib/home-visits-icon.svg";

    const {formID = 9} = $props(); // TODO: CHANGE THIS DEFAULT VALUE

    const {
        CHECKLISTS_HOME_VISITS_MANAGE,
        CHECKLISTS_HOME_VISITS_PDF,
        CHECKLISTS_HOME_VISITS_GLOBAL_LIST
    } = ACTIONS;

    let loading = $state(true);

    let isExistingHomeVisitForm = $derived(Number.isInteger(parseInt(formID)));
    
    /**
     * @type {{
     * userActions: number[]
     * businessRules: BusinessRule[]
     * applicationConfig: {[x: string]: string;}
     * userData: Object|false
     }} */
    let userSecurity = $state.raw({
        userActions: [],
        businessRules: [],
        applicationConfig: {},
        userData: false
    });

    let formDisabledBySecurity = $derived.by(function () {
        return userSecurity.userActions.includes(CHECKLISTS_HOME_VISITS_MANAGE) === false;
    });

    /**
     * @typedef {object} HomeVisitFormFullObject
     * @property {object} main
     * @property {string} main.id
     * @property {string} main.cons_id
     * @property {string} main.name
     * @property {string} main.visit_date_time
     * @property {string} main.visit_date
     * @property {string} main.visit_time
     * @property {string} main.announced
     * @property {string} main.provider
     * @property {string} main.residential_vendor
     * @property {string} main.program_manager
     * @property {string} main.people_present
     * @property {string} main.program_manager_visit_dates
     * @property {string} main.program_nurse_visit_dates
     * @property {string} main.health_status
     * @property {string} main.hrst_review
     * @property {string} main.followup_needed
     * @property {string} main.behavior_plan
     * @property {string} main.comments
     * @property {string} main.created
     * @property {string} main.created_by
     * @property {string} main.created_by_employer
     * @property {string} main.updated
     * @property {string} main.updated_by
     * @property {string} main.signed
     * @property {string} main.signed_by
     * @property {string} main.deleted
     * @property {string} main.deleted_by
     * @property {object[]} questions
     * @property {number} questions[].id
     * @property {string} questions[].form
     * @property {number} questions[].version
     * @property {string} questions[].section
     * @property {string} questions[].section_number
     * @property {string} questions[].question_prefix
     * @property {string} questions[].question_number
     * @property {string} questions[].question_text
     * @property {string} questions[].extra
     * @property {object[]} fields
     * @property {number} fields[].id
     * @property {string} fields[].checklist_id
     * @property {number} fields[].version
     * @property {string} fields[].group_id
     * @property {string} fields[].field_type
     * @property {string} fields[].field_label
     * @property {string} fields[].field_sort
     * @property {string} fields[].field_position
     * @property {string} fields[].field_height
     * @property {string} fields[].max_length
     * @property {string} fields[].field_value
     * @property {object[]} responses
     * @property {number} responses[].field_id
     * @property {number} responses[].question
     * @property {string} responses[].response
     */
    /** @type {HomeVisitFormFullObject} */
    // @ts-ignore
    let homeVisitDetails = $state({
        "main": {
            "id": "",
            "cons_id": "",
            "name": "",
            "visit_date_time": "",
            "visit_date": "",
            "visit_time": "",
            "announced": "",
            "provider": "",
            "residential_vendor": "",
            "program_manager": "",
            "people_present": "",
            "program_manager_visit_dates": "",
            "program_nurse_visit_dates": "",
            "health_status": "",
            "hrst_review": "",
            "followup_needed": "",
            "behavior_plan": "",
            "comments": "",
            "created": "",
            "created_by": "",
            "created_by_employer": "",
            "updated": "",
            "updated_by": "",
            "signed": "",
            "signed_by": "",
            "deleted": "",
            "deleted_by": ""
        },
        "questions": [
            {
                "id": 1,
                "form": "home_visit",
                "version": 1,
                "section": null,
                "section_number": 1,
                "question_prefix": null,
                "question_number": 1,
                "question_text": "Individual's Personal Appearance",
                "extra": null
            },
            {
                "id": 2,
                "form": "home_visit",
                "version": 1,
                "section": null,
                "section_number": 1,
                "question_prefix": null,
                "question_number": 2,
                "question_text": "General Conditions of the Home; sufficient food supplied",
                "extra": null
            },
            {
                "id": 3,
                "form": "home_visit",
                "version": 1,
                "section": null,
                "section_number": 1,
                "question_prefix": null,
                "question_number": 3,
                "question_text": "Individual's Bedroom",
                "extra": null
            },
            {
                "id": 4,
                "form": "home_visit",
                "version": 1,
                "section": null,
                "section_number": 1,
                "question_prefix": null,
                "question_number": 4,
                "question_text": "Relationship & Observed Interactions",
                "extra": null
            },
            {
                "id": 5,
                "form": "home_visit",
                "version": 1,
                "section": null,
                "section_number": 1,
                "question_prefix": null,
                "question_number": 5,
                "question_text": "Review that ISA is being implemented",
                "extra": null
            },
            {
                "id": 6,
                "form": "home_visit",
                "version": 1,
                "section": null,
                "section_number": 1,
                "question_prefix": null,
                "question_number": 6,
                "question_text": "Review CPS Notes",
                "extra": null
            },
            {
                "id": 7,
                "form": "home_visit",
                "version": 1,
                "section": null,
                "section_number": 1,
                "question_prefix": null,
                "question_number": 7,
                "question_text": "Activities/Participation in the Home/Community",
                "extra": null
            },
            {
                "id": 8,
                "form": "home_visit",
                "version": 1,
                "section": null,
                "section_number": 1,
                "question_prefix": null,
                "question_number": 8,
                "question_text": "Review of Medication Log",
                "extra": null
            },
            {
                "id": 9,
                "form": "home_visit",
                "version": 1,
                "section": null,
                "section_number": 1,
                "question_prefix": null,
                "question_number": 9,
                "question_text": "Fire Safety; Alarms & clear egresses",
                "extra": null
            },
            {
                "id": 10,
                "form": "home_visit",
                "version": 1,
                "section": null,
                "section_number": 1,
                "question_prefix": null,
                "question_number": 10,
                "question_text": "Review Fire Drill Reports",
                "extra": null
            }
        ],
        "fields": [
            {
                "id": 9,
                "checklist_id": 3,
                "version": 1,
                "group_id": 1,
                "field_type": "radio",
                "field_label": "1",
                "field_sort": 1,
                "field_position": "",
                "field_height": null,
                "max_length": null,
                "field_value": "1"
            },
            {
                "id": 10,
                "checklist_id": 3,
                "version": 1,
                "group_id": 1,
                "field_type": "radio",
                "field_label": "2",
                "field_sort": 2,
                "field_position": "",
                "field_height": null,
                "max_length": null,
                "field_value": "2"
            },
            {
                "id": 11,
                "checklist_id": 3,
                "version": 1,
                "group_id": 1,
                "field_type": "radio",
                "field_label": "3",
                "field_sort": 3,
                "field_position": "",
                "field_height": null,
                "max_length": null,
                "field_value": "3"
            },
            {
                "id": 12,
                "checklist_id": 3,
                "version": 1,
                "group_id": null,
                "field_type": "textarea",
                "field_label": "Comments",
                "field_sort": 4,
                "field_position": "column",
                "field_height": 2,
                "max_length": 255,
                "field_value": ""
            }
        ],
        "responses": []
    });

    let hvIsSigned = $derived(homeVisitDetails?.main.signed?.length > 0);
    let dateOfSignature = $derived(homeVisitDetails.main.signed);
    let hvSignedBy = $derived(homeVisitDetails.main.signed_by || userSecurity.userData?.id);
    let canUnsign = false;

    const switchOptions = [
        { label: "", value: "1" },
        { label: "", value: "2" },
        { label: "", value: "3" }
    ];

    let logDisplayed = $state(false);

    let initialValues = $derived({
        id: (homeVisitDetails.main.id ?? "") + "",
        hv_date: homeVisitDetails.main.visit_date ?? "",
        hv_time: homeVisitDetails.main.visit_time ?? "",
        hv_announced: homeVisitDetails.main.announced ?? "",
        hv_provider: homeVisitDetails.main.provider ?? "",
        hv_residential_vendor: homeVisitDetails.main.residential_vendor ?? "",
        hv_program_manager: homeVisitDetails.main.program_manager ?? "",
        hv_people_present: homeVisitDetails.main.people_present ?? "",
        hv_program_manager_visit_dates: homeVisitDetails.main.program_manager_visit_dates ?? "",
        hv_program_nurse_visit_dates: homeVisitDetails.main.program_nurse_visit_dates ?? "",
        hv_health_status: homeVisitDetails.main.health_status ?? "",
        hv_hrst_review: homeVisitDetails.main.hrst_review ?? "",
        hv_followup_needed: homeVisitDetails.main.followup_needed ?? "",
        hv_behavior_plan: homeVisitDetails.main.behavior_plan ?? "",
        hv_comments: homeVisitDetails.main.comments ?? "",
        hv_signed: homeVisitDetails.main.signed ?? "",
        hv_signed_by: homeVisitDetails.main.signed_by ?? "",
        questions: homeVisitDetails.questions || [],
        q1_set_value: homeVisitDetails.responses.find(r => (r.question === 1 && r.field_id === 1))?.response || "",
        q1_comments: homeVisitDetails.responses.find(r => (r.question === 1 && r.field_id === 4))?.response || "",
        q2_set_value: homeVisitDetails.responses.find(r => (r.question === 2 && r.field_id === 1))?.response || "",
        q2_comments: homeVisitDetails.responses.find(r => (r.question === 2 && r.field_id === 4))?.response || "",
        q3_set_value: homeVisitDetails.responses.find(r => (r.question === 3 && r.field_id === 1))?.response || "",
        q3_comments: homeVisitDetails.responses.find(r => (r.question === 3 && r.field_id === 4))?.response || "",
        q4_set_value: homeVisitDetails.responses.find(r => (r.question === 4 && r.field_id === 1))?.response || "",
        q4_comments: homeVisitDetails.responses.find(r => (r.question === 4 && r.field_id === 4))?.response || "",
        q5_set_value: homeVisitDetails.responses.find(r => (r.question === 5 && r.field_id === 1))?.response || "",
        q5_comments: homeVisitDetails.responses.find(r => (r.question === 5 && r.field_id === 4))?.response || "",
        q6_set_value: homeVisitDetails.responses.find(r => (r.question === 6 && r.field_id === 1))?.response || "",
        q6_comments: homeVisitDetails.responses.find(r => (r.question === 6 && r.field_id === 4))?.response || "",
        q7_set_value: homeVisitDetails.responses.find(r => (r.question === 7 && r.field_id === 1))?.response || "",
        q7_comments: homeVisitDetails.responses.find(r => (r.question === 7 && r.field_id === 4))?.response || "",
        q8_set_value: homeVisitDetails.responses.find(r => (r.question === 8 && r.field_id === 1))?.response || "",
        q8_comments: homeVisitDetails.responses.find(r => (r.question === 8 && r.field_id === 4))?.response || "",
        q9_set_value: homeVisitDetails.responses.find(r => (r.question === 9 && r.field_id === 1))?.response || "",
        q9_comments: homeVisitDetails.responses.find(r => (r.question === 9 && r.field_id === 4))?.response || "",
        q10_set_value: homeVisitDetails.responses.find(r => (r.question === 10 && r.field_id === 1))?.response || "",
        q10_comments: homeVisitDetails.responses.find(r => (r.question === 10 && r.field_id === 4))?.response || "",
    });

    let pageTitle = "Home Visit Form";

    let field_margin_classes = "mb-4 mb-lg-4";

    // for dropdowns
    let announced = [
        {value: "N", label: "Unannounced"},
        {value: "Y", label: "Announced"}
    ];

    let yes_no_map = [
        {value: "N", label: "No"},
        {value: "Y", label: "Yes"}
    ];

    let startTimeOptions = generate_time_array(5);
    
    const form_props = {
        validationSchema: yup.object().shape({
            hv_date: yup.date(),
            hv_time: yup.string(),
            hv_announced: yup.string(),
            hv_provider: yup.string(),
            hv_residential_vendor: yup.string(),
            hv_program_manager: yup.string(),
            hv_people_present: yup.string(),
            hv_program_manager_visit_dates: yup.string(),
            hv_program_nurse_visit_dates: yup.string(),
            hv_health_status: yup.string(),
            hv_hrst_review: yup.string(),
            hv_followup_needed: yup.string(),
            hv_behavior_plan: yup.string(),
            hv_comments: yup.string(), 
        })
    };

    const { form, errors, handleSubmit, updateInitialValues, isValid } = createForm(
        {
            initialValues,
            validationSchema: form_props.validationSchema,
            onSubmit: () => {},
        });
    
    let defaultFormProps = $derived({
        loading,
        autoupdate: isExistingHomeVisitForm,
        disabled: formDisabledBySecurity || !isExistingHomeVisitForm || $form.hv_signed.length > 0,
        onUpdate: on_update,
        onupdate: on_update,
        route: `cm/home_visits/update/main`,
        entityID: formID
    });

    $effect(function () {
        // allows us to update the initial form values when changed via an
        // api call (update or load)
        updateInitialValues(initialValues);
    });

    $effect(function load() {
        dressing.api.get_user_security().then(
            (
                response
            ) => {
                if (response.success === true) {
                    const {business_rules, application_config, logged_in_user, logged_in} = response;

                    const securityData = {
                        businessRules: business_rules || [],
                        userActions: logged_in_user.actions || [],
                        applicationConfig: application_config || {},
                        userData: logged_in_user || false,
                    };

                    // @ts-ignore;
                    userSecurity = securityData;
                    
                    userSecurity.userData = securityData.userData;
                    userSecurity.applicationConfig = securityData.applicationConfig;
                    userSecurity.businessRules = securityData.businessRules;
                    userSecurity.userActions = securityData.userActions;

                    if (!securityData.userActions.includes(CHECKLISTS_HOME_VISITS_MANAGE)) {
                        const security_error = create_security_error("App.svelte", "HomeVisitForm",
                        CHECKLISTS_HOME_VISITS_MANAGE);
                        dressing.api.report_security_error(security_error);
                    }

                    if (parseInt(formID) > 0) {
                        dressing.get(`/cm/home_visits/${formID}`)
                            .then(function ({data: res}) {
                                if (res.success === true) {
                                    homeVisitDetails = res.data.home_visit;
                                }
                            }).catch(function (error) {
                                console.error("Error fetching home visit details", error);
                                toast.error("Error fetching home visit details");
                            });
                    } else {
                        const security_error = create_security_error("App.svelte",
                            "HomeVisitForm", CHECKLISTS_HOME_VISITS_MANAGE);

                        dressing.api.report_security_error(security_error)
                            .then(function () {
                                // regardless of response, log out
                                dressing.api.logout();
                            });
                        return;
                    }

                    loading = false;
                } else {
                    console.error("Error fetching user security data", response);
                }
            }
        );
    });

    function on_update({field, value}) {
        homeVisitDetails[field] = value;
    }

    /**
     * Handles the signature update for the ICAP form.
     * It sends a request to update the signature status of the ICAP form, after verifying the form is validly filled.
     * @param {boolean} is_signed
     */
    function handle_signature(is_signed) {
        if (typeof is_signed === "boolean") {
            const event = new Event("submit", {bubbles: false, cancelable: true});
            handleSubmit(event).then(() => {
                // If the form is valid, we can proceed with the signature update
                if ($isValid || !is_signed) {
                    dressing.post(`cm/home_visits/update/main`, {
                        id: formID,
                        field: "signed",
                        value: is_signed
                    }).then(function ({data: res}) {
                        if (res.success === true) {
                            homeVisitDetails = res.data.home_visit;
                        } else {
                            toast.error("Failed to update signature.");
                        }
                    });
                }
            }).catch((error) => {
                console.error("Error during form submission:", error);
            });
        }
    }

    function displayLogs() {
        logDisplayed = !logDisplayed;
    }
</script>

<Breadcrumb divider={" "} class="breadcrumbs mb-3">
    <BreadcrumbItem>
        Case Management
    </BreadcrumbItem>
    <BreadcrumbItem class="mx-3">
        <Icon icon="chevron-right"/>
    </BreadcrumbItem>
    <BreadcrumbItem>
        <a href="/index.php?action={CHECKLISTS_HOME_VISITS_GLOBAL_LIST}">
            <span class="me-2">
                <img src={homeVisitsBreadcrumb} height="13" width="13" alt="page-icon"/>
            </span>
            Home Visits
        </a>
    </BreadcrumbItem>
    <BreadcrumbItem class="mx-3">
        <Icon icon="chevron-right"/>
    </BreadcrumbItem>
    <BreadcrumbItem>
        View / Edit
    </BreadcrumbItem>
</Breadcrumb>
<!-- Page Title -->
<h1>
    {#if isExistingHomeVisitForm}
        <!-- <img src={homeVisitsIcon} height="48" width="48" alt="page-icon"/> -->
        {pageTitle} for {homeVisitDetails.main.name}
    {/if}
</h1>
<!-- Export Buttons -->
<div class="d-flex w-100 justify-content-end mb-3">
    <ExportButtons
        show={["pdf"]}
        href="/index.php?action={CHECKLISTS_HOME_VISITS_PDF}&id={formID}"
    />
</div>
<!-- Form -->
<form onsubmit={handleSubmit}>
    {#key homeVisitDetails}
        <fieldset disabled={loading} id="loading-fieldset">
            <Row class="">
                <Col xs="12" lg="4" class={field_margin_classes}>
                    <AutoUpdateInput
                        fieldName="visit_date"
                        bind:defaultValue={$form.hv_date}
                        invalid={$errors.hv_date.length > 0}
                        invalidMessage="Please provide a valid date"
                        type="date"
                        label="Home Visit Date"
                        {...defaultFormProps}
                        />
                </Col>
                <Col xs="12" lg="4" class={field_margin_classes}>
                    <AutoUpdateInput
                        fieldName="visit_time"
                        route={`cm/home_visits/update/main`}
                        bind:defaultValue={$form.hv_time}
                        type="select"
                        invalid={$errors.hv_time.length > 0}
                        invalidMessage="Please select a time"
                        optionsFrom={startTimeOptions}
                        label="Home Visit Time"
                        {...defaultFormProps}
                    />
                </Col>
                <Col xs="12" lg="4" class={field_margin_classes}>
                    <AutoUpdateInput
                        fieldName="announced"
                        route={`cm/home_visits/update/main`}
                        bind:defaultValue={$form.hv_announced}
                        type="select"
                        invalid={$errors.hv_announced.length > 0}
                        invalidMessage="Was this visit announced?"
                        optionsFrom={announced}
                        label="Announced?"
                        {...defaultFormProps}
                    />
                </Col>
                <Col xs="12" lg="4" class={field_margin_classes}>
                    <AutoUpdateInput
                        fieldName="provider"
                        route={`cm/home_visits/update/main`}
                        bind:defaultValue={$form.hv_provider}
                        type="text"
                        invalid={$errors.hv_provider.length > 0}
                        invalidMessage="Please provide a valid provider"
                        label="Home Provider"
                        {...defaultFormProps}
                    />
                </Col>
                <Col xs="12" lg="4" class={field_margin_classes}>
                    <AutoUpdateInput
                        fieldName="residential_vendor"
                        route={`cm/home_visits/update/main`}
                        bind:defaultValue={$form.hv_residential_vendor}
                        type="text"
                        invalid={$errors.hv_residential_vendor.length > 0}
                        invalidMessage="Please provide a valid residential vendor"
                        label="Residential Vendor"
                        {...defaultFormProps}
                    />
                </Col>
                <Col xs="12" lg="4" class={field_margin_classes}>
                    <AutoUpdateInput
                        fieldName="program_manager"
                        route={`cm/home_visits/update/main`}
                        bind:defaultValue={$form.hv_program_manager}
                        type="text"
                        invalid={$errors.hv_program_manager.length > 0}
                        invalidMessage="Please provide a valid program manager"
                        label="Program Manager"
                        {...defaultFormProps}
                    />
                </Col>
                <Col xs="12" lg="4" class={field_margin_classes}>
                    <AutoUpdateInput
                        fieldName="people_present"
                        route={`cm/home_visits/update/main`}
                        bind:defaultValue={$form.hv_people_present}
                        type="text"
                        invalid={$errors.hv_people_present.length > 0}
                        invalidMessage="Please add the people present"
                        label="People Present"
                        {...defaultFormProps}
                    />
                </Col>
            </Row>
            {#each $form.questions as question}
                <Row class={(question.id % 2 === 1 ? "bg-secondary-50" : "") + " py-2 py-lg-0"}>
                    <Col xs="12" lg="4" class="d-flex">
                        <div class="my-auto">{question.question_text}</div>
                    </Col>
                    <Col xs="12" lg="4" class="d-flex mt-3 mt-lg-0">
                        <div class="my-auto w-100">
                            <AutoUpdateSet
                                fieldName={`q${question.id}_set_value`}
                                bind:defaultValue={$form[`q${question.id}_set_value`]}
                                type="switch"
                                label="Acceptable - Concern - Unacceptable"
                                fields={switchOptions}
                                bordered={true}
                                showInline={true}
                                autoupdate={isExistingHomeVisitForm}
                                {...defaultFormProps}
                                route={`cm/home_visits/update/responses`}
                            />
                        </div>
                    </Col>
                    <Col xs="12" lg="4">
                        <AutoUpdateInput
                            fieldName={`q${question.id}_comments`}
                            bind:defaultValue={$form[`q${question.id}_comments`]}
                            type="textarea"
                            label=""
                            {...defaultFormProps}
                            route={`cm/home_visits/update/responses`}
                            rows="1"
                        />
                    </Col>
                </Row>
            {/each}
            <Row>
                <Col xs="12" lg="6" class={field_margin_classes}>
                    <AutoUpdateInput
                        fieldName="program_manager_visit_dates"
                        route={`cm/home_visits/update/main`}
                        bind:defaultValue={$form.hv_program_manager_visit_dates}
                        type="text"
                        invalid={$errors.hv_program_manager_visit_dates.length > 0}
                        invalidMessage="Please provide a valid program manager visit dates"
                        label="Dates of Program Manager Visits"
                        {...defaultFormProps}
                    />
                </Col>
                <Col xs="12" lg="6" class={field_margin_classes}>
                    <AutoUpdateInput
                        fieldName="program_nurse_visit_dates"
                        route={`cm/home_visits/update/main`}
                        bind:defaultValue={$form.hv_program_nurse_visit_dates}
                        type="text"
                        invalid={$errors.hv_program_nurse_visit_dates.length > 0}
                        invalidMessage="Please provide a valid program nurse visit dates"
                        label="Dates of Program Nurse Visits"
                        {...defaultFormProps}
                    />
                </Col>
                <Col xs="12" lg="6" class={field_margin_classes}>
                    <AutoUpdateInput
                        fieldName="health_status"
                        route={`cm/home_visits/update/main`}
                        bind:defaultValue={$form.hv_health_status}
                        type="text"
                        invalid={$errors.hv_health_status.length > 0}
                        invalidMessage="Please provide a valid health status"
                        label="Health Status"
                        {...defaultFormProps}
                    />
                </Col>
                <Col xs="12" lg="6" class={field_margin_classes}>
                    <AutoUpdateInput
                        fieldName="hrst_review"
                        route={`cm/home_visits/update/main`}
                        bind:defaultValue={$form.hv_hrst_review}
                        type="select"
                        invalid={$errors.hv_hrst_review.length > 0}
                        invalidMessage="Please select a hrst review"
                        optionsFrom={yes_no_map}
                        label="Reviewed HRST Monthly Tracker with Provider"
                        {...defaultFormProps}
                    />
                </Col>
                <Col xs="12" lg="6" class={field_margin_classes}>
                    <AutoUpdateInput
                        fieldName="followup_needed"
                        route={`cm/home_visits/update/main`}
                        bind:defaultValue={$form.hv_followup_needed}
                        type="textarea"
                        invalid={$errors.hv_followup_needed.length > 0}
                        invalidMessage="Please provide a valid followup needed"
                        label="Follow Up Needed"
                        {...defaultFormProps}
                    />
                </Col>
                <Col xs="12" lg="6" class={field_margin_classes}>
                    <AutoUpdateInput
                        fieldName="behavior_plan"
                        route={`cm/home_visits/update/main`}
                        bind:defaultValue={$form.hv_behavior_plan}
                        type="textarea"
                        invalid={$errors.hv_behavior_plan.length > 0}
                        invalidMessage="Please provide a valid behavior plan"
                        label="Behavior Plan"
                        {...defaultFormProps}
                    />
                </Col>
                <Col xs="12" lg="6" class={field_margin_classes}>
                    <AutoUpdateInput
                        fieldName="comments"
                        route={`cm/home_visits/update/main`}
                        bind:defaultValue={$form.hv_comments}
                        type="textarea"
                        invalid={$errors.hv_comments.length > 0}
                        invalidMessage="Please provide a valid comment"
                        label="Comments"
                        {...defaultFormProps}
                    />
                </Col>
            </Row>
            <Row>
                <Col xs="12" lg="6">
                    <wa-callout variant="neutral" class="rounded-2">
                        {#if !hvIsSigned}
                            <strong>By clicking this button, you are attesting that this Home Visit Report is complete and in its final form.</strong>
                        {/if}

                        {#if hvIsSigned}
                            <h4>Submitted by</h4>
                        {/if}

                        <AutoPen
                                userID={hvSignedBy}
                                allowUnsign={canUnsign}
                                isSigned={hvIsSigned}
                                confirmButton="Finalize Home Visit Report"
                                showOptions={{
                                    name: true,
                                    credentials: true,
                                    employer: true,
                                    date: dateOfSignature,
                                    signature: true,
                                    title: true
                                }}
                                onupdate={function(result) {
                                    handle_signature(result.isSigned);
                                }}
                        />

                    </wa-callout>
                </Col>
            </Row>
            {#if !isExistingHomeVisitForm}
                <Button color="primary" class="rounded-pill">submit</Button>
            {/if}
        </fieldset>
    {/key}
</form>
<button id="change_log_button" class="btn btn-primary btn-sm rounded-pill mt-4" onclick={displayLogs}>
    {"Change Log"}
</button>
<MegaPopup
    bind:active={logDisplayed}
    for="change_log_button"
    placement="top-start">
    <div class="pt-2 px-3 rounded-2 bg-white">
        <EntityChangeHistory entity={"checklist_home_visit"} id={$form.id}></EntityChangeHistory>
    </div>
</MegaPopup>